var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",[_c('span',{staticClass:"question-id"},[_vm._v(" Q"+_vm._s(_vm.id)+" ")])],{id:_vm.id})],2)}
var staticRenderFns = []

export { render, staticRenderFns }